import { useLocation } from 'react-router-dom'

const useGetPathname = () => {
  const { pathname } = useLocation()

  // remove slash before pathname
  const pathnameWithoutSlash = pathname.replace('/', '')

  return { pathname, pathnameWithoutSlash }
}

export default useGetPathname
